import { Box, Grid } from '@mui/material';
import { CartItem } from '../../../app/data/models/cart';
import CartItemCard from './CartItemCard';

interface CartItemListProps {
  cartItems: CartItem[];
  defaultTaxRate: number;
  onQuantityChange: (item: CartItem, quantity: number) => void;
}

export const CartItemList = ({
  cartItems,
  defaultTaxRate,
  onQuantityChange,
}: CartItemListProps) => (
  <Box>
    <Grid container spacing={2}>
      {cartItems.map((cartItem) => (
        <Grid key={cartItem.mealItemId} item xs={12}>
          <CartItemCard
            cartItem={cartItem}
            defaultTaxRate={defaultTaxRate}
            onQuantityChange={(quantity) =>
              onQuantityChange(cartItem, quantity)
            }
          />
        </Grid>
      ))}
    </Grid>
  </Box>
);
